import { booleanSelectValue, getPath, isYes } from "../logic/paths";
import { yesNoItems } from "../options";
import SectionCard from "../ui/SectionCard";
import { GlobeIcon } from "../ui/icons";
import SegmentedPills from "../ui/fields/SegmentedPills";
import { StepViewProps } from "./types";

const FATCA_ROWS: Array<[string, string]> = [
  ["FATCA.usCitizen", "Are you a U.S. citizen?"],
  ["FATCA.usResident", "Are you a U.S. resident?"],
  ["FATCA.usAlien", "Are you a U.S. resident alien?"],
  ["FATCA.usPhone", "Do you have a current U.S. telephone number?"],
  ["FATCA.usBorn", "Were you born in the U.S.?"],
  ["FATCA.usAddressResidence", "Do you have a current U.S. residence address?"],
  ["FATCA.usAddressMailing", "Do you have a current U.S. mailing address (incl. U.S. P.O.)?"],
  ["FATCA.usAccount", "Have you issued a standing instruction to transfer funds to a U.S. account?"],
  ["FATCA.usPOA", "Have you granted power of attorney / signatory authority to a person with a U.S. address?"],
  ["FATCA.usCareOfAddress", "Do you have an \u201cin care of\u201d or \u201chold mail\u201d address as the sole address for an account?"],
];

export default function Fatca({ state, handlers }: StepViewProps) {
  const { draft, errors } = state;
  const kyc = draft.kyc;
  const isUsPerson = isYes(getPath(kyc, "FATCA.usPerson"));

  return (
    <SectionCard title="FATCA declaration" icon={<GlobeIcon size={18} />}>
      <SegmentedPills
        label="Are you a U.S. person for tax purposes?"
        required
        value={booleanSelectValue(getPath(kyc, "FATCA.usPerson"))}
        options={yesNoItems}
        error={errors["FATCA.usPerson"]}
        onChange={(v) => handlers.setKycField("FATCA.usPerson", v)}
      />

      {isUsPerson && (
        <div style={{ marginTop: 12 }}>
          {FATCA_ROWS.map(([path, label]) => (
            <SegmentedPills
              key={path}
              row
              label={label}
              required
              value={booleanSelectValue(getPath(kyc, path))}
              options={yesNoItems}
              error={errors[path]}
              onChange={(v) => handlers.setKycField(path, v)}
            />
          ))}
        </div>
      )}
    </SectionCard>
  );
}
